import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  List,
  ListItem,
} from "@chakra-ui/react";

const PROPERTY_STATUS_COLORS = {
  pending_verification: { bg: "#FEF3C7", text: "#92400E" },
  active: { bg: "#D1FAE5", text: "#065F46" },
  expired: { bg: "#FEE2E2", text: "#7F1D1D" },
  deleted: { bg: "#F3E8FF", text: "#581C87" },
  inactive: { bg: "#E0E7FF", text: "#312E81" },
  rejected: { bg: "#FECACA", text: "#7F1D1D" },
};

const getStatusColor = (status) => {
  return PROPERTY_STATUS_COLORS[status] || { bg: "#F3F4F6", text: "#374151" };
};

const AddPropertyModal = ({ isOpen, onClose, properties = [], onSubmit }) => {
  const [selectedProperty, setSelectedProperty] = useState(null);

  const handleSubmit = () => {
    if (selectedProperty) {
      onSubmit(selectedProperty);
      onClose();
    }
  };

  const handleListItemClick = (property) => {
    setSelectedProperty(property);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Property</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {properties.length > 0 ? (
            <List spacing={3}>
              {properties.map((property) => (
                <ListItem
                  key={property._id}
                  p={2}
                  bg={
                    selectedProperty?._id === property._id
                      ? "blue.500"
                      : "gray.100"
                  }
                  color={
                    selectedProperty?._id === property._id ? "white" : "inherit"
                  }
                  onClick={() => handleListItemClick(property)}
                  style={{ cursor: "pointer", borderRadius: "md" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <a
                      href={`${process.env.REACT_APP_HEXAHOME_BASE_URL}/${property.slug_url}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        textDecoration: "none",
                        color:
                          selectedProperty?._id === property._id
                            ? "white"
                            : "inherit",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {property.slug_url}
                    </a>
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        padding: "4px 8px",
                        borderRadius: "4px",
                        backgroundColor:
                          selectedProperty?._id === property._id
                            ? "rgba(255, 255, 255, 0.3)"
                            : getStatusColor(property.property_status).bg,
                        color:
                          selectedProperty?._id === property._id
                            ? "white"
                            : getStatusColor(property.property_status).text,
                        textTransform: "capitalize",
                        marginLeft: "8px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {property.property_status?.replace(/_/g, " ")}
                    </span>
                  </div>
                </ListItem>
              ))}
            </List>
          ) : (
            <p>No properties available.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
            color="#ffffff"
            mr={3}
            onClick={handleSubmit}
            disabled={!selectedProperty}
          >
            Submit
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddPropertyModal;
